import { PaymentModal } from "./PaymentModal";

export function ModalProvider() {
  return (
    <>
      <PaymentModal />
    </>
  );
}
